import styled from 'styled-components';
// eslint-disable-next-line import/no-extraneous-dependencies
import { spacing } from '@material-ui/system';
import { Box as MuiBox } from '@material-ui/core';

const Box = styled(MuiBox)(spacing);

export default Box;
